// Gallery controls for each .blocks__gallery instance
function initGalleryControls() {
  document.querySelectorAll('.blocks__gallery').forEach(gallery => {
    const media = gallery.querySelector('.blocks__gallery__media');
    const items = media ? Array.from(media.children) : [];
    const prevBtn = gallery.querySelector('.blocks__gallery__controls__prev');
    const nextBtn = gallery.querySelector('.blocks__gallery__controls__next');
    let current = 0;

    if (!media || !prevBtn || !nextBtn || items.length === 0) return;

    // Helper: scroll to item by index
    function scrollToIndex(idx, smooth = true) {
      if (idx < 0 || idx >= items.length) return;
      const item = items[idx];
      if (!item) return;
      const left = item.offsetLeft - media.offsetLeft;
      media.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
      current = idx;
      updateControls();
    }

    // Helper: update button states and active class
    function updateControls() {
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current === items.length - 1;
      items.forEach((el, i) => el.classList.toggle('active', i === current));
    }

    // Button events
    prevBtn.addEventListener('click', () => {
      if (current > 0) scrollToIndex(current - 1);
    });
    nextBtn.addEventListener('click', () => {
      if (current < items.length - 1) scrollToIndex(current + 1);
    });

    // Update current index on manual scroll
    let scrollTimeout;
    media.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        // Find the item closest to the left edge
        let minDist = Infinity;
        let idx = current;
        const mediaRect = media.getBoundingClientRect();
        items.forEach((item, i) => {
          const rect = item.getBoundingClientRect();
          const dist = Math.abs(rect.left - mediaRect.left);
          if (dist < minDist) {
            minDist = dist;
            idx = i;
          }
        });
        if (idx !== current) {
          current = idx;
          updateControls();
        }
      }, 100);
    });

    // --- Draggable/Swipe to scroll ---
    // Only enable mouse drag on non-touch devices
    if (!('ontouchstart' in window)) {
      let isDown = false;
      let startX;
      let scrollLeft;

      media.addEventListener('mousedown', (e) => {
        isDown = true;
        media.classList.add('dragging');
        startX = e.pageX - media.offsetLeft;
        scrollLeft = media.scrollLeft;
      });
      media.addEventListener('mouseleave', () => {
        isDown = false;
        media.classList.remove('dragging');
      });
      media.addEventListener('mouseup', () => {
        isDown = false;
        media.classList.remove('dragging');
      });
      media.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - media.offsetLeft;
        const walk = (x - startX) * 1.2; // drag speed
        media.scrollLeft = scrollLeft - walk;
      });
    }


    // --- Autoplay/pause videos when in view ---
    const videos = media.querySelectorAll('video');
    if (videos.length && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.play && entry.target.play();
          } else {
            entry.target.pause && entry.target.pause();
          }
        });
      }, {
        root: media,
        threshold: 0.5 // Play when at least 50% in view
      });
      videos.forEach(video => observer.observe(video));
    }

    // Initial state
    updateControls();
  });
}

// Auto-init on DOMContentLoaded
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initGalleryControls);
}

export { initGalleryControls };



